import { render, staticRenderFns } from "./FormPackagePermissions.vue?vue&type=template&id=30038821"
import script from "./FormPackagePermissions.vue?vue&type=script&lang=js"
export * from "./FormPackagePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports